export default __webpack_public_path__ + "static/media/error_message.d1fc33da.svg";